import React, { useCallback, useEffect, useState } from "react";
import CareerPageHeader from "../../components/CareerPageHeader/CareerPageHeader";
import CarrerPageCard from "../../components/CarerrPageCard/CarrerPageCard";
import Loader from "../../components/common/Loader/Loader";
import { CompanyService } from "../../services";
import parse from "html-react-parser";
import PageNotFound from "../../components/common/noDatafound/PageNotFound";
import InfiniteScroll from "react-infinite-scroller";
import config from "../../config";
import { getHost } from "../../helpers";
import NoJobAvailable from "../../components/common/noDatafound/NoJobAvailable";

async function fetchIssues(url) {
  const response = await fetch(url, {
    method: "GET",
    headers: new Headers({
      Accept: "application/vnd.github.v3+json",
    }),
  });

  const results = await response.json();
  return results;
}

function CareerPage() {
  const [companyData, setCompanyData] = useState(null);
  const [jobDetails, setjobDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    CompanyService.getCompanyPage()
      .then((res) => {
        if (res) {
          setCompanyData(res);
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  }, []);

  //pagination
  const [nextPageUrl, setNextPageUrl] = useState(
    `${config.atsApiUrl}/careers/jobs?page_size=15`
  );
  const [items, setItems] = useState([]);
  const [fetching, setFetching] = useState(false);

  const fetchItems = useCallback(async () => {
    if (fetching) {
      return;
    }

    setFetching(true);
    try {
      const results = await fetchIssues(nextPageUrl);

      setItems([...items, ...results?.results]);

      if (results?.nextUrl) {
        setNextPageUrl(config.atsApiUrl + results?.nextUrl);
      } else {
        setNextPageUrl(null);
      }
    } finally {
      setFetching(false);
    }
  }, [items, fetching, nextPageUrl]);

  useEffect(() => {
    fetchItems();
  }, []);

  const hasMoreItems = !!nextPageUrl;

  useEffect(() => {
    if (companyData && companyData?.favicon?.url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = companyData?.favicon?.url;
    }
    if (companyData?.name) {
      document.title = companyData?.name;
    }
  }, [companyData]);

  const [carrerBody, setCarrerBody] = useState({});
  const [fontColor, setFontColor] = useState({});
  const [subTitleStyle, setSubTitleStyle] = useState({
    textAlign: "justify",
    color: "#FFFFFF",
    fontFamily: `"Montserrat", Sans-serif`,
    fontSize: "18px",
    fontWeight: 500,
  });

  useEffect(() => {
    if (
      companyData &&
      companyData?.banner &&
      companyData?.banner?.bannerImage
    ) {
      setCarrerBody({
        backgroundImage: `url('${companyData?.banner?.bannerImage?.url}')`,
      });
    }
  }, [companyData]);

  const fontBold = {
    fontWeight: "600",
  };

  useEffect(() => {
    if (companyData && companyData?.fontColor) {
      setFontColor({ color: companyData?.fontColor });
      setSubTitleStyle({ ...subTitleStyle, color: companyData?.fontColor });

      document.title = companyData?.pagetitle
      document.querySelector('meta[name="description"]').setAttribute("content", companyData?.meta);
    }
  }, [companyData]);

  return companyData ? (
    <div className="content-area">
      <CareerPageHeader companyData={companyData} />
      <div className="mainBannerPart" style={carrerBody ? carrerBody : ""}>
        <div className="container mainConatiner">
          <div className="banner-data">
            <div className="row">
              <div className="col-12 col-md-8  margin-top-7rem margin-bottom-10rem">
                <h1
                  className="bannerMainTitle"
                  style={fontColor ? fontColor : ""}
                >
                  {companyData?.banner?.bannerTitle
                    ? parse(companyData?.banner?.bannerTitle)
                    : ""}
                </h1>
                <div className="paragraph-container">
                  <p style={subTitleStyle}>
                    {companyData?.banner?.bannerDetail
                      ? parse(companyData?.banner?.bannerDetail)
                      : ""}
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4 "> </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container creerContainer">
        <div className="row mt-4">
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <h2 className="bodyTitle">
              {companyData?.body?.bodyTitle
                ? parse(companyData?.body?.bodyTitle)
                : ""}
            </h2>
          </div>
          <div className="col-12 col-md-6 ">
            <p className="pt-4">
              {companyData?.body?.bodyDetail
                ? parse(companyData?.body?.bodyDetail)
                : ""}
            </p>
          </div>
        </div>
        <div className=" d-flex justify-content-center">
          <h3 className="bodyDetails mt-5" style={fontBold}>
            {companyData?.body?.openingTitle
              ? parse(companyData?.body?.openingTitle)
              : ""}
          </h3>
        </div>

        <InfiniteScroll
          dataLength={items.length}
          className="px-5"
          loadMore={fetchItems}
          hasMore={hasMoreItems}
          loader={fetching && <Loader color="#5382ba" height={50} width={50} />}
          endMessage={!fetching && items.length === 0 && <p>No Openings</p>}
        >
          <div className="row">
            {items.map((item) => (
              <div className="col-12 col-sm-6 col-md-4 ">
                <CarrerPageCard
                  fontBold={fontBold}
                  data={item}
                  fontColor={fontColor}
                />
              </div>
            ))}
            {!fetching && items.length === 0 ? <NoJobAvailable /> : null}
          </div>
        </InfiniteScroll>
      </div>
    </div>
  ) : loading ? (
    <div className="middelLoader">
      <Loader color="#5382ba" />
    </div>
  ) : (
    <PageNotFound />
  );
}

export default CareerPage;
